import { useContext } from 'react'

// Context
import { ZillowContext } from '../../contexts'
import { AppContext } from '../../contexts/AppContext'

// This should be used in most cases and is useful for Storybook
export const useZillowListingUrl = () => {
  const { proxiedZillowUrl } = useContext(ZillowContext)
  const { devMode } = useContext(AppContext)

  return devMode
    ? proxiedZillowUrl
    : window.location.origin + window.location.pathname
}
